import React, { useEffect, useMemo, useRef, useState } from "react"
import { Card, Container, Row, Col, ModalBody, ModalHeader } from "reactstrap"
import { FaUserFriends, FaDumbbell, FaClipboardList } from "react-icons/fa"
import moment from "moment-timezone"
import "react-big-calendar/lib/css/react-big-calendar.css"
import "react-big-calendar/lib/addons/dragAndDrop/styles.css"

import Breadcrumb from "components/Common/Breadcrumb"
import ActivityModal from "../Plans/addActivity" // Your activity modal
import WorkoutModal from "pages/Workouts/addWorkout"
import { FaPlus, FaX } from "react-icons/fa6"
import { Modal } from "reactstrap"

import { Select, Switch } from "antd"
import {
  fetchData,
  FetchDeleteData,
  FetchPostData,
  FetchPutData,
} from "utils/Common_api_functions"
import Loader from "components/Loader/loader"
import Swal from "sweetalert2"
import TrainingPlanCalendar from "./TrainingPlanCalendar"
import UserCalendar from "./UserCalendar"
import SidebarPanel from "./Sidebar"
import activities from "utils/Activities"

const CalendarIndex = () => {
  const [activePanel, setActivePanel] = useState(null)
  const [loading, setLoading] = useState(false)
  const [events, setEvents] = useState([])
  const [selectedUser, setSelectedUser] = useState(null)
  const [users, setUsers] = useState([])
  const [allusers, setallUsers] = useState([])
  const [userOptions, setUserOptions] = useState([])

  const [trainingPlans, setTrainingPlans] = useState([])

  useEffect(() => {
    getUsers()
    getUserData()
    getPlanData()
  }, [])

  async function getUsers() {
    const APIData = await fetchData(setLoading, "user")

    if (APIData?.success) {
      setallUsers(APIData?.users)
      setUserOptions(
        APIData.users.map(item => ({
          value: item._id,
          label: item.name,
        }))
      )
    }
  }

  async function getPlanData() {
    const APIData = await fetchData(setLoading, "training/plan")

    if (APIData?.success) {
      setTrainingPlans(APIData?.plans)
    }
  }

  async function getUserData() {
    const APIData = await fetchData(setLoading, "user/club/wise")
    if (APIData?.success && APIData?.clubs?.length) {
      const clubs = APIData.clubs
      setUsers(clubs)

      // 🔍 Find the first club that actually has users
      const firstClubWithUsers = clubs.find(club => club?.users?.length > 0)
      const firstUser = firstClubWithUsers?.users?.[0]

      if (!selectedUser && firstUser?._id) {
        console.log(firstUser._id)
        setSelectedUser(firstUser._id)
        setEvents(firstUser?.workoutCalender || [])
      }
    }
  }

  const [trainingPlanSearch, setTrainingPlanSearch] = useState("")
  const [selectedPlan, setSelectedPlan] = useState(null)
  const [viewingPlanMode, setViewingPlanMode] = useState(false)
  const [isPlanModalVisible, setIsPlanModalVisible] = useState(false)
  const [planModalMode, setPlanModalMode] = useState("add") // or "edit"
  const [planForm, setPlanForm] = useState({
    planName: "",
    users: [] || undefined,
    planType: "free",
    price: "",
    bannerImage: null,
    events: [] || undefined,
    description: "",
    type: "",
    duration: "",
    linkToFreeUser: false,
  })

  useEffect(() => {
    if (viewingPlanMode) {
      setViewingPlanMode(false)
      setSelectedPlan(null)
    }
  }, [selectedUser])

  const getMaxAllowedDays = (duration, type) => {
    const d = Number(duration)

    switch (type) {
      case "day":
        return d
      case "week":
        return d * 7
      case "month":
        return d * 30 // or 28 / calendar-based if you prefer
      default:
        return 0
    }
  }

  const maxDays = getMaxAllowedDays(planForm.duration, planForm.type)

  async function handlePlanSubmit() {
    if (planModalMode === "add") {
      const APIData = await FetchPostData(
        setLoading,
        "/training/plan",
        planForm
      )

      if (APIData?.data?.success) {
        Swal.fire({
          title: "Training Plan Added Successfully",
          icon: "success",
        })
        getPlanData()
        setPlanForm({
          planName: "",
          users: [],
          planType: "free",
          price: "",
          bannerImage: null,
          events: [],
          description: "",
          duration: "",
          type: "",
          linkToFreeUser: false,
        })
        setIsPlanModalVisible(false)
      } else {
        Swal.fire({
          title: "Something went wrong",
          icon: "error",
          text: APIData?.response?.data?.message,
        })
      }
    } else if (planModalMode === "edit" && selectedPlan) {
      const { events, ...payload } = planForm

      console.log(events)

      const filteredEvents = planForm.events.filter(event => {
        const day = event.dayNumber?.[0]
        return typeof day === "number" && day >= 1 && day <= maxDays
      })
      const finalPayload = {
        ...payload,
        events: filteredEvents,
      }
      const APIData = await FetchPutData(
        setLoading,
        `training/plan`,
        selectedPlan._id,
        finalPayload
      )
      if (APIData?.data?.success) {
        Swal.fire({
          title: "Training Plan Updated Successfully",
          icon: "success",
        })
        getPlanData()
        setPlanForm({
          planName: "",
          users: [],
          planType: "free",
          price: "",
          bannerImage: null,
          events: [],
          description: "",
          type: "",
          duration: "",
          linkToFreeUser: false,
        })
        setIsPlanModalVisible(false)
      } else {
        Swal.fire({
          title: "Something went wrong",
          icon: "error",
          text: APIData?.response?.data?.message,
        })
      }
    }
  }

  const handleDeleteTraningPlan = userId => {
    Swal.fire({
      title: "Are you sure?",
      text: "This action will permanently delete the Training Plan.",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      cancelButtonColor: "#3085d6",
      confirmButtonText: "Yes, delete it!",
    }).then(async result => {
      if (result.isConfirmed) {
        try {
          const res = await FetchDeleteData(setLoading, `training/plan`, userId)

          if (res?.data?.success) {
            Swal.fire("Deleted!", "Training Plan has been deleted.", "success")
            getPlanData()
          } else {
            Swal.fire(
              "Error",
              res?.response?.data?.message || "Something went wrong.",
              "error"
            )
          }
        } catch (error) {
          Swal.fire(
            "Error",
            "An error occurred while deleting the Training Plan.",
            "error"
          )
          console.error(error)
        }
      }
    })
  }

  // workouts state is now local and mutable
  const [workouts, setWorkouts] = useState([])
  const [selectedActivity, setselectedActivity] = useState(null)

  const [isModalOpen, setIsModalOpen] = useState(false)
  const [modalEvent, setModalEvent] = useState(null)
  const [modalDate, setModalDate] = useState(null)

  const [isActivityModalOpen, setIsActivityModalOpen] = useState(false)

  const draggedWorkoutRef = useRef(null)

  const [searchTerm, setSearchTerm] = useState("")

  useEffect(() => {
    getWorkouts()
  }, [])

  useEffect(() => {
    setEvents([]) // reset previous events
    if (selectedUser) {
      const eventsData = allusers?.find(item => item?._id === selectedUser)
      setEvents(eventsData?.workoutCalender || [])
    }
  }, [selectedUser])

  async function getWorkouts() {
    const APIData = await fetchData(setLoading, "workout")

    if (APIData?.success) {
      setWorkouts(APIData?.workouts?.filter(item => item?.type === false))
    }
  }

  const onDragStart = (e, workout) => {
    draggedWorkoutRef.current = workout
    e.dataTransfer.effectAllowed = "copy"
  }

  const getDraggedEvent = () => {
    if (!draggedWorkoutRef.current) return null
    return {
      title: draggedWorkoutRef.current.activityTitle || "Untitled Workout",
      start: new Date(), // temporary, will be updated on drop
      end: start,
      allDay: false,
      workout: draggedWorkoutRef.current._id,
    }
  }

  const handleDropFromOutside = async ({ start, allDay, dayNumber }) => {
    const workout = draggedWorkoutRef.current
    if (!workout) return

    const newEvent = {
      title: workout.activityTitle || "Untitled Workout",
      start,
      end: start,
      allDay,
      workout: workout._id,
    }

    if (viewingPlanMode && dayNumber) {
      newEvent.dayNumber = [dayNumber]
    }

    // Optimistic update
    setEvents(prev => [...prev, newEvent])

    const endpoint = viewingPlanMode
      ? "training/plan/insert/workout"
      : "user/insert/workout"
    const targetId = viewingPlanMode ? selectedPlan._id : selectedUser

    try {
      const APIdata = await FetchPutData(setLoading, endpoint, targetId, {
        event: newEvent,
      })

      if (!APIdata?.data?.success) throw new Error(APIdata?.res?.message)

      const updatedEvents =
        APIdata?.data?.events || APIdata?.data?.workoutCalender || []
      const normalized = updatedEvents.map(ev => ({
        ...ev,
        title: ev.title || ev.workout?.activityTitle || "Untitled Workout",
        start: new Date(ev.start),
        end: new Date(ev.end),
      }))

      console.log(normalized);

      if (viewingPlanMode && selectedPlan) {
        setSelectedPlan(prev => ({ ...prev, events: normalized }))
        setTrainingPlans(prev =>
          prev.map(p =>
            p._id === selectedPlan._id ? { ...p, events: normalized } : p
          )
        )
      } else {
        setallUsers(prev =>
          prev.map(u =>
            u._id === selectedUser ? { ...u, workoutCalender: normalized } : u
          )
        )
        setUsers(prev =>
          prev.map(c => ({
            ...c,
            users: c.users.map(u =>
              u._id === selectedUser ? { ...u, workoutCalender: normalized } : u
            ),
          }))
        )
        setEvents(normalized)
      }
    } catch (err) {
      Swal.fire({
        title: "Error",
        icon: "error",
        text: err.message || "Failed to add workout",
      })
      setEvents(prev => prev.filter(ev => ev !== newEvent))
    }

    draggedWorkoutRef.current = null
  }

  const handleDeleteEvent = async event => {
    console.log(event)
    if (!event?.event?._id && !event?._id) return

    const targetId = viewingPlanMode ? selectedPlan._id : selectedUser
    const endpoint = viewingPlanMode
      ? "training/plan/remove/workout"
      : "user/remove/workout"

    try {
      const APIdata = await FetchPutData(setLoading, endpoint, targetId, {
        eventId: event?.event ? event?.event?._id : event?._id,
      })

      if (!APIdata?.data?.success) throw new Error("Failed to delete event")

      const updatedEvents =
        APIdata?.data?.events || APIdata?.data?.workoutCalender || []
      const normalized = updatedEvents.map(ev => ({
        ...ev,
        title: ev.title || ev.workout?.activityTitle || "Untitled Workout",
        start: new Date(ev.start),
        end: new Date(ev.end),
      }))

      if (viewingPlanMode) {
        setSelectedPlan(prev => ({ ...prev, events: normalized }))
        setTrainingPlans(prev =>
          prev.map(p =>
            p._id === selectedPlan._id ? { ...p, events: normalized } : p
          )
        )
      } else {
        setEvents(normalized)
        setallUsers(prev =>
          prev.map(u =>
            u._id === selectedUser ? { ...u, workoutCalender: normalized } : u
          )
        )
        setUsers(prev =>
          prev.map(c => ({
            ...c,
            users: c.users.map(u =>
              u._id === selectedUser ? { ...u, workoutCalender: normalized } : u
            ),
          }))
        )
      }

      console.log("Event Deleted ✅")
    } catch (err) {
      Swal.fire({
        title: "Error",
        icon: "error",
        text: err.message || "Something went wrong",
      })
    }
  }

  const onEventDrop = async ({ event, start, end, isAllDay }) => {
    if (!event?._id) return

    const updatedEvent = {
      ...event,
      start,
      end,
      allDay: isAllDay ?? event.allDay,
      ...(viewingPlanMode && { dayNumber: event?.dayNumber }),
    }

    draggedWorkoutRef.current = null

    const endpoint = viewingPlanMode
      ? "training/plan/update/workout"
      : "user/update/workout"
    const targetId = viewingPlanMode ? selectedPlan._id : selectedUser

    try {
      const APIdata = await FetchPutData(setLoading, endpoint, targetId, {
        updatedEvent,
      })

      if (!APIdata?.data?.success) throw new Error(APIdata?.res?.message)

      const updatedEvents =
        APIdata?.data?.events || APIdata?.data?.workoutCalender || []
      const normalized = updatedEvents.map(ev => ({
        ...ev,
        title: ev.title || ev.workout?.activityTitle || "Untitled Workout",
        start: new Date(ev.start),
        end: new Date(ev.end),
      }))

      if (viewingPlanMode) {
        setSelectedPlan(prev => ({ ...prev, events: normalized }))
        setTrainingPlans(prev =>
          prev.map(p =>
            p._id === selectedPlan._id ? { ...p, events: normalized } : p
          )
        )
      } else {
        setEvents(normalized)
        setallUsers(prev =>
          prev.map(u =>
            u._id === selectedUser ? { ...u, workoutCalender: normalized } : u
          )
        )
        setUsers(prev =>
          prev.map(c => ({
            ...c,
            users: c.users.map(u =>
              u._id === selectedUser ? { ...u, workoutCalender: normalized } : u
            ),
          }))
        )
      }

      console.log("Event updated ✅")
    } catch (err) {
      Swal.fire({
        title: "Error",
        icon: "error",
        text: err.message || "Failed to update event",
      })
    }
  }

  const onEventResize = async ({ event, start, end }) => {
    if (!event?._id) return

    const startDay = moment(start).startOf("day")
    const endDay = moment(end).startOf("day")
    const daysDiff = endDay.diff(startDay, "days")

    // Create array of day numbers
    const dayNumbers = []
    if (viewingPlanMode && event?.dayNumber[0]) {
      for (let i = 0; i < daysDiff; i++) {
        dayNumbers.push(event?.dayNumber[0] + i)
      }
    }

    const updatedEvent = {
      ...event,
      start,
      end,
      ...(viewingPlanMode && { dayNumber: dayNumbers }),
    }

    draggedWorkoutRef.current = null

    const endpoint = viewingPlanMode
      ? "training/plan/update/workout"
      : "user/update/workout"
    const targetId = viewingPlanMode ? selectedPlan._id : selectedUser

    try {
      const APIdata = await FetchPutData(setLoading, endpoint, targetId, {
        updatedEvent,
      })

      if (!APIdata?.data?.success) throw new Error(APIdata?.res?.message)

      const updatedEvents =
        APIdata?.data?.events || APIdata?.data?.workoutCalender || []
      const normalized = updatedEvents.map(ev => ({
        ...ev,
        title: ev.title || ev.workout?.activityTitle || "Untitled Workout",
        start: new Date(ev.start),
        end: new Date(ev.end),
      }))

      if (viewingPlanMode) {
        setSelectedPlan(prev => ({ ...prev, events: normalized }))
        setTrainingPlans(prev =>
          prev.map(p =>
            p._id === selectedPlan._id ? { ...p, events: normalized } : p
          )
        )
      } else {
        setEvents(normalized)
        setallUsers(prev =>
          prev.map(u =>
            u._id === selectedUser ? { ...u, workoutCalender: normalized } : u
          )
        )
        setUsers(prev =>
          prev.map(c => ({
            ...c,
            users: c.users.map(u =>
              u._id === selectedUser ? { ...u, workoutCalender: normalized } : u
            ),
          }))
        )
      }

      console.log("Event resized ✅")
    } catch (err) {
      Swal.fire({
        title: "Error",
        icon: "error",
        text: err.message || "Failed to resize event",
      })
    }
  }

  const handleSelectEvent = event => {
    setModalEvent(event)
    setModalDate(event.start)
    setIsModalOpen(true)
  }

  // Save new workout added from modal
  const handleSaveNewWorkout = async (activityData, editid) => {
    if (editid) {
      const APIData = await FetchPutData(
        setLoading,
        "workout",
        editid,
        activityData
      )

      if (APIData?.data?.success) {
        Swal.fire({
          title: "Workout Updated Successfully",
          icon: "success",
        })
        getPlanData()
        getUserData()
        getWorkouts()
      } else {
        Swal.fire({
          title: "Something went wrong",
          icon: "error",
          description: APIData?.response?.data?.message,
        })
      }
    } else {
      const APIData = await FetchPostData(setLoading, "workout", activityData)

      if (APIData?.data?.success) {
        Swal.fire({
          title: "Workout Added Successfully",
          icon: "success",
        })
        getPlanData()
        getUserData()
        getWorkouts()
      } else {
        Swal.fire({
          title: "Something went wrong",
          icon: "error",
          description: APIData?.response?.data?.message,
        })
      }
    }
  }

  const handleWorkoutDelete = id => {
    Swal.fire({
      title: "Are you sure?",
      text: "This action will permanently delete this Workout Item.",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      cancelButtonColor: "#3085d6",
      confirmButtonText: "Yes, delete it!",
    }).then(async result => {
      if (result.isConfirmed) {
        const APIData = await FetchDeleteData(setLoading, "workout", id)

        if (APIData?.data?.success) {
          Swal.fire({
            title: "Workout Deleted Successfully",
            icon: "success",
          })
          getPlanData()
          getUserData()
          getWorkouts()
        } else {
          Swal.fire({
            title: "Something went wrong",
            icon: "error",
            description: APIData?.response?.data?.message,
          })
        }
      }
    })
  }

  const sidebarProps = {
    activePanel,
    setActivePanel,
    users,
    setUsers,
    selectedUser,
    setSelectedUser,
    getUserData,
    workouts,
    searchTerm,
    setSearchTerm,
    onDragStart,
    setselectedActivity,
    setIsActivityModalOpen,
    handleWorkoutDelete,
    trainingPlans,
    trainingPlanSearch,
    setTrainingPlanSearch,
    setPlanForm,
    setPlanModalMode,
    setIsPlanModalVisible,
    selectedPlan,
    setSelectedPlan,
    setViewingPlanMode,
    handleDeleteTraningPlan,
  }

  return (
    <div className="page-content px-0">
      {loading && <Loader />}
      <Container fluid>
        <Breadcrumb title="" breadcrumbItem="Calendar" />
        <Row className="min-vh-100">
          <Col xl={1} className="border-end p-0 text-center">
            <div className="d-flex flex-column align-items-center py-3 gap-3">
              <div
                className={`icon-nav border border-dark rounded-3 p-2 ${
                  activePanel === "athletes" ? "text-primary" : "text-muted"
                }`}
                onClick={() => setActivePanel("athletes")}
                style={{ cursor: "pointer" }}
              >
                <FaUserFriends size={20} />
                <div style={{ fontSize: "12px" }}>Athlete Library</div>
              </div>
              <div
                className={`icon-nav border border-dark rounded-3 p-2 ${
                  activePanel === "workouts" ? "text-primary" : "text-muted"
                }`}
                onClick={() => setActivePanel("workouts")}
                style={{ cursor: "pointer" }}
              >
                <FaDumbbell size={20} />
                <div style={{ fontSize: "12px" }}>Workout Library</div>
              </div>
              <div
                className={`icon-nav border border-dark rounded-3 p-2 ${
                  activePanel === "training" ? "text-primary" : "text-muted"
                }`}
                onClick={() => setActivePanel("training")}
                style={{ cursor: "pointer" }}
              >
                <FaClipboardList size={20} />
                <div style={{ fontSize: "12px" }}>Training Plans</div>
              </div>
            </div>
          </Col>

          {activePanel && (
            <Col xl={3}>
              <SidebarPanel {...sidebarProps} />
            </Col>
          )}

          <Col xl={activePanel ? 8 : 11}>
            <Card className="h-100">
              {viewingPlanMode && selectedPlan ? (
                <TrainingPlanCalendar
                  selectedPlan={selectedPlan}
                  getDraggedEvent={getDraggedEvent}
                  handleSelectEvent={handleSelectEvent}
                  activities={activities}
                  handleDropFromOutside={handleDropFromOutside}
                  onEventResize={onEventResize}
                  handleDeleteEvent={handleDeleteEvent}
                  setEvents={setEvents}
                  setselectedActivity={setselectedActivity}
                  onEventDrop={onEventDrop}
                  setLoading={setLoading}
                  setSelectedPlan={setSelectedPlan}
                  setTrainingPlans={setTrainingPlans}
                />
              ) : (
                <UserCalendar
                  events={events}
                  draggedWorkoutRef={draggedWorkoutRef}
                  selectedUser={selectedUser}
                  handleSelectEvent={handleSelectEvent}
                  activities={activities}
                  handleDropFromOutside={handleDropFromOutside}
                  onEventResize={onEventResize}
                  setSelectedUser={setSelectedUser}
                  userOptions={userOptions}
                  onEventDrop={onEventDrop}
                  getDraggedEvent={getDraggedEvent}
                  handleDeleteEvent={handleDeleteEvent}
                  setEvents={setEvents}
                  setallUsers={setallUsers}
                  setUsers={setUsers}
                  setLoading={setLoading}
                />
              )}
            </Card>
          </Col>
        </Row>

        {/* Edit Activity Modal */}
        <ActivityModal
          isOpen={isModalOpen}
          toggle={() => setIsModalOpen(!isModalOpen)}
          date={modalDate}
          event={modalEvent}
          onSave={handleSaveNewWorkout}
        />

        {/* Add Workout Modal */}
        <WorkoutModal
          isOpen={isActivityModalOpen}
          toggle={() => setIsActivityModalOpen(!isActivityModalOpen)}
          onSave={handleSaveNewWorkout}
          event={selectedActivity}
        />

        {/* Plan Modal */}
        <Modal
          isOpen={isPlanModalVisible}
          toggle={() => setIsPlanModalVisible(false)}
          footer={null}
          centered
          size="lg"
        >
          <ModalHeader toggle={() => setIsPlanModalVisible(false)}>
            {planModalMode === "add" ? "Add Plan" : "Edit Plan"}
          </ModalHeader>
          <ModalBody>
            <div className="">
              {/* Plan Name */}
              <Row>
                <Col md={8}>
                  <label className="form-label">Plan Name</label>
                  <input
                    type="text"
                    className="form-control mb-3"
                    value={planForm.planName}
                    onChange={e =>
                      setPlanForm(prev => ({
                        ...prev,
                        planName: e.target.value,
                      }))
                    }
                    placeholder="Enter plan name"
                  />
                </Col>
                <Col md={4}>
                  <div className="d-flex flex-column">
                    <label className="form-label mb-2">
                      Link to User's Free Package
                    </label>
                    <Switch
                      style={{ width: "10%" }}
                      checked={planForm.linkToFreeUser}
                      onChange={status => {
                        if (status === true) {
                          const data = trainingPlans.filter(
                            item => item?.linkToFreeUser === true
                          )

                          console.log(planForm?.planName, data?.[0]?.planName)

                          if (
                            planForm?.planName !== data?.[0]?.planName &&
                            data.length > 0
                          ) {
                            Swal.fire({
                              title: "Already Assigned",
                              text: "You have already assigned any other training plan to user plan , please remove that first.",
                              icon: "warning",
                            })
                          } else {
                            setPlanForm(prev => ({
                              ...prev,
                              linkToFreeUser: status,
                            }))
                          }
                        } else {
                          setPlanForm(prev => ({
                            ...prev,
                            linkToFreeUser: status,
                          }))
                        }
                      }}
                    />
                  </div>
                </Col>
              </Row>

              {planModalMode === "add" && (
                <Col md={6}>
                  {/* Duration Selection */}
                  <label className="form-label">
                    Select Plan to Copy all the Activity
                  </label>
                  <Select
                    className="w-100 mb-3"
                    value={planForm?.copyPlan}
                    onChange={selectedOption => {
                      const ExistingPlan = trainingPlans?.find(
                        item => item?._id == selectedOption
                      )

                      setPlanForm(prev => ({
                        ...prev,
                        copyPlan: selectedOption,
                        planType : ExistingPlan?.planType,
                        price : ExistingPlan?.price,
                        duration : ExistingPlan?.duration,
                        type : ExistingPlan?.type
                      }))
                    }}
                    options={trainingPlans?.map(item => ({
                      label: item.planName, // 👈 change key if needed
                      value: item._id,
                    }))}
                    placeholder="Select plan to Copy all Activity"
                  />
                </Col>
              )}

              {!planForm.linkToFreeUser && (
                <>
                  <Row>
                    <Col md={6}>
                      <label className="form-label">Plan Type</label>
                      <Select
                        className="w-100 mb-3"
                        value={planForm.planType}
                        onChange={value =>
                          setPlanForm(prev => ({ ...prev, planType: value }))
                        }
                        options={[
                          { value: "free", label: "Free" },
                          { value: "paid", label: "Paid" },
                        ]}
                        placeholder="Select plan type"
                      />
                    </Col>
                    <Col md={6}>
                      {/* Price only if Paid */}
                      {planForm.planType === "paid" && (
                        <div>
                          <label className="form-label">Price (£)</label>
                          <input
                            type="number"
                            className="form-control mb-3"
                            value={planForm.price}
                            min={0}
                            onChange={e =>
                              setPlanForm(prev => ({
                                ...prev,
                                price: e.target.value,
                              }))
                            }
                            placeholder="Enter price in pounds"
                            required
                          />
                        </div>
                      )}
                    </Col>
                  </Row>

                  <Row>
                    <Col md={6}>
                      <div>
                        <label className="form-label">Duration</label>
                        <input
                          type="number"
                          className="form-control mb-3"
                          value={planForm.duration}
                          min={0}
                          onChange={e =>
                            setPlanForm(prev => ({
                              ...prev,
                              duration: e.target.value,
                            }))
                          }
                          placeholder="Enter Duration"
                          required
                        />
                      </div>
                    </Col>
                    <Col md={6}>
                      {/* Duration Selection */}
                      <label className="form-label">Duration Type</label>
                      <Select
                        className="w-100 mb-3"
                        value={planForm.type}
                        onChange={value =>
                          setPlanForm(prev => ({ ...prev, type: value }))
                        }
                        options={[
                          { value: "day", label: "Days" },
                          { value: "week", label: "Week" },
                          { value: "month", label: "Month" },
                        ]}
                        placeholder="Select plan duration"
                      />
                    </Col>
                  </Row>

                  <div className="mb-3">
                    <label className="form-label">Plan Description</label>
                    <textarea
                      type="text"
                      className="form-control"
                      value={planForm?.description}
                      onChange={e =>
                        setPlanForm(prev => ({
                          ...prev,
                          description: e.target.value || "",
                        }))
                      }
                    />
                  </div>

                  {/* Banner Image Upload */}
                  <div className="mb-3">
                    <label className="form-label">Banner Image</label>
                    <input
                      type="file"
                      className="form-control"
                      accept="image/*"
                      onChange={e =>
                        setPlanForm(prev => ({
                          ...prev,
                          bannerImage: e.target.files[0] || null,
                        }))
                      }
                    />
                  </div>

                  {/* Users Multi-Select */}
                  <label className="form-label">Users</label>
                  <Select
                    mode="multiple"
                    allowClear
                    className="w-100 mb-3"
                    placeholder="Select users"
                    optionFilterProp="label"
                    value={planForm.users}
                    onChange={selected =>
                      setPlanForm(prev => ({ ...prev, users: selected }))
                    }
                    options={userOptions}
                  />
                </>
              )}

              {/* Submit / Cancel */}
              <div className="d-flex justify-content-end mt-3 align-items-center">
                <div className="d-flex gap-3">
                  <button
                    className="btn btn-add"
                    onClick={() => handlePlanSubmit()}
                  >
                    <FaPlus className="me-1" size={14} />
                    Submit
                  </button>
                  <button
                    className="btn bg-danger text-white"
                    onClick={() => setIsPlanModalVisible(false)}
                  >
                    <FaX className="me-1" size={14} />
                    Cancel
                  </button>
                </div>
              </div>
            </div>
          </ModalBody>
        </Modal>
      </Container>
    </div>
  )
}

export default CalendarIndex
